import { render } from "./Index-Arc.vue?vue&type=template&id=73b28992"
import script from "./Index-Arc.vue?vue&type=script&lang=js"
export * from "./Index-Arc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__